var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-nav-bar',{attrs:{"title":_vm.title,"left-text":"","right-text":""}}),_c('EpisodeList',{attrs:{"slug":_vm.slug,"editorChoiceOnly":false,"publicOnly":true,"limit":0},on:{"got-episodes-count":_vm.gotEpisodesCount}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }